import { type CertData } from '../api/interfaces/sconnStudyData'
import { type CheckboxItemCertData } from '../components/ExaminationSelect'

export const userGroups = [
  {
    id: 'college',
    name: 'group',
    value: 'college',
    label: '대학생',
  },
  {
    id: 'repeater',
    name: 'group',
    value: 'repeater',
    label: 'N수생/반수생',
  },
  {
    id: 'highschool',
    name: 'group',
    value: 'highschool',
    label: '고등학생',
  },
  {
    id: 'middleschool',
    name: 'group',
    value: 'middleschool',
    label: '중학생',
  },
  {
    id: 'elemantaryschool',
    name: 'group',
    value: 'elemantaryschool',
    label: '초등학생',
  },
  {
    id: 'general',
    name: 'group',
    value: 'general',
    label: '일반인',
    description: '( 자격증, 취업, 공무원, 전문직 등..)',
  },
]

/** default examinatins 10개 선정 기본 시험 항목 */
export const EXAM_OPTIONS: CheckboxItemCertData[] = [
  {
    id: '0',
    code: 'add-button',
    name: '시험 찾아보기',
    type: '',
    checked: false,
    keyWords: '',
    manageHostName: '',
  },
  {
    id: '11',
    code: 'none',
    name: '준비중인 시험 없음',
    type: '',
    checked: false,
    keyWords: '',
    manageHostName: '',
  },
]

const combinedExams = [...EXAM_OPTIONS]
// const sortedExams = combinedExams.sort((a, b) => a.id - b.id)

export const EXAM_PRESET: CertData[] = combinedExams
